import React from 'react';
import { useAtomValue } from 'jotai';
import {
  hintDetailAtom,
  hintExpiryDateAtom,
  isHintSubsRecurringAtom,
  shouldSubscribeHintAtom,
} from '@components/subscription/store/HintPaymentAtoms';
import { moneyFormatter } from '@components/subscription/helper/SubscriptionHelper';

const HintPaymentCardContent = () => {
  const isRecurring = useAtomValue(isHintSubsRecurringAtom);
  const hintDetail = useAtomValue(hintDetailAtom);
  const shouldSubscribe = useAtomValue(shouldSubscribeHintAtom);
  const expiryDateMoment = useAtomValue(hintExpiryDateAtom);

  if (!hintDetail) {
    return null;
  }

  const addOnPriceHumanized = () => {
    // for now we hardcode it to SGD 15/month
    return moneyFormatter('SGD', 15) + '/month';

    // return (
    //   moneyFormatter(
    //     hintDetail.currency_code,
    //     hintDetail.normal_price * (1 + hintDetail.gst_rate),
    //   ) +
    //   '/' +
    //   (hintDetail.billing_frequency > 1
    //     ? hintDetail.billing_frequency +
    //       ' ' +
    //       hintDetail.billing_period.toLowerCase() +
    //       's'
    //     : hintDetail.billing_period.toLowerCase())
    // );
  };

  const expiryDate = expiryDateMoment?.format('D MMMM YYYY');

  if (shouldSubscribe) {
    return (
      <div data-testid={'should-subscribe'}>
        Get personalised help for challenging questions with Hints, available at{' '}
        <strong>{addOnPriceHumanized()}</strong>
      </div>
    );
  }

  if (isRecurring) {
    return (
      <div data-testid={'recurring'}>
        Hints at {addOnPriceHumanized()} automatically renews each{' '}
        {hintDetail.billing_period.toLowerCase()} on {expiryDate}
      </div>
    );
  }

  return (
    <div data-testid={'not-recurring'}>
      You will no longer have access to hints on {expiryDate}
    </div>
  );
};

export default HintPaymentCardContent;
